<template>
<div>
    <v-card>

        <v-toolbar dark flat color="primary">
            <v-toolbar-title>Edit Semester</v-toolbar-title>
        </v-toolbar>

        <div v-if="laravelErrors.active" class="text-xs-center pa-3">
            <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">
                {{ msg }}
            </v-chip>
        </div>

        <v-form @submit.prevent="updateSemester" class="pa-5">
            <v-layout row wrap align-center>
                <v-flex xs12>
                    <v-layout row align-center>
                        <v-text-field name="name" label="Name" class="pr-5" :disabled="disableNameField" v-model="semester.name"></v-text-field>
                        <v-btn color="red" icon small @click="disableNameField = !disableNameField">
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                    </v-layout>
                </v-flex>
                <v-flex xs12 class="mb-3">
                    <p class="subheading"><i>* Editing a semester name will update all classes, schedules and enrollment history logs that are tied to this semester</i></p>
                </v-flex>
                <v-flex xs12>
                    <v-checkbox name="active" label="active" v-model="semester.active"></v-checkbox>
                </v-flex>
                <v-flex xs12>
                    <v-checkbox name="disable" label="disable" v-model="semester.disabled"></v-checkbox>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="updateSemester">Update</v-btn>
            </v-layout>
        </v-form>

    </v-card>

    <v-dialog v-model="updateSuccessAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert class="title" :value="true" type="success">Semester Successfully Updated!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="updateSuccessAlert = false">Ok!</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
export default {
    props: {
        semester: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            disableNameField: true,
            updateSuccessAlert: false
        }
    },
    computed: {
        laravelErrors() {
            return this.$store.state.errorModule.validation
        }
    },
    mounted() {
        this.$root.$on('resetEditOptions', () => this.disableNameField = true)
    },
    methods: {
        updateSemester() {
            this.$store.commit('clearErrors')

            let payload = {
                id: this.semester.id,
                name: this.semester.name,
                active: this.semester.active ? 1 : 0,
                disabled: this.semester.disabled ? 1 : 0
            }

            this.$store.dispatch('updateSemester', payload)
                .then(() => {
                    this.updateSuccessAlert = true
                })
                .catch(() => {})
        }
    }
}
</script>
